'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("itHeaderManager", function () {
  return function (tableCtrl) {
    var manager = this,
      $scope = tableCtrl.getScope(),
      linkers = tableCtrl.linkers,
      context = tableCtrl.getContext(),
      ui = tableCtrl.ui,
      columnsParentScope = null;

    /**
     *
     */
    manager.constructColGroups = function () {
      var headerCols = [];
      var contentCols = [];
      var footerCols = [];

      // iterates on visible columns to create associated col element
      _.each(context.visibleColumns, function (computed) {
        if (!computed.visible) {
          return;
        }
        computed.headerCol = $(document.createElement("col"));
        computed.contentCol = $(document.createElement("col"));
        computed.footerCol = $(document.createElement("col"));
        headerCols.push(computed.headerCol[0]);
        contentCols.push(computed.contentCol[0]);
        footerCols.push(computed.footerCol[0]);
      });

      // adds the scrollbar col
      headerCols.push($('<col class="scrollbar">')[0]);
      contentCols.push($('<col class="scrollbar">')[0]);
      footerCols.push($('<col class="scrollbar">')[0]);

      // appends only once to avoid multiple repaint
      ui.headColgroup.empty().append(headerCols);
      ui.contentColgroup.empty().append(contentCols);
      ui.footerColgroup.empty().append(footerCols);
    };

    /**
     *
     */
    manager.constructHeaders = function () {
      if (columnsParentScope != null) {
        columnsParentScope.$destroy();
        ui.headTable.find('thead').empty();
        ui.contentHeadRow.empty();
      }
      columnsParentScope = $scope.$new();

      // var computedColumns = context.columns;
      var hasGroups = context.hasHeaderGroups;
      var headerRow = createHeadHeaderRow();
      var headerCellLinker = linkers.headerCell;
      var contentHeaderCellLinker = linkers.contentHeaderCell;
      var headerGroupRow,
        groupCellLinker,
        lastGroup = null;
      if (hasGroups) {
        headerGroupRow = createHeadGroupRow();
        groupCellLinker = linkers.headerGroupCell;
      }
      _.each(context.visibleColumns, function (computed) {
        var group = computed.group;
        var column = computed.column;
        var columnScope = columnsParentScope.$new();
        columnScope.column = computed;

        // add group row cell if necessary
        if (group && group !== lastGroup) {
          lastGroup = group;

          // calculating effective colspan ( visible = false )
          var colspan = 0;
          for (var colIdx = group.fromColumn; colIdx <= group.toColumn; colIdx++) {
            if (context.columns[colIdx].visible) {
              colspan++;
            }
          }
          var groupScope = columnsParentScope.$new();
          groupScope.group = group;
          groupCellLinker(groupScope, function (headerCell) {
            headerCell.text(group.title);
            headerCell.attr("colspan", colspan);
            if (group.id) {
              headerCell.attr("data-group-id", group.id);
            }
            if (group.tooltip) {
              var $el = headerCell;
              var tooltipContainer = $("<div>").addClass("it-tooltip-content").html(group.tooltip).appendTo($el);
              $el.addClass("it-has-tooltip");
              $el.qtip({
                content: {
                  text: tooltipContainer
                },
                show: {
                  delay: 450
                },
                position: {
                  // se passe mal dès que la page est trop longue - mais a priori inutile donc on met en commentaire
                  //  container: $el.closest(".infini-table"),
                  my: 'top center',
                  at: 'bottom center',
                  adjust: {
                    y: 8
                  }
                },
                style: {
                  classes: 'qtip-it-header'
                }
              });
              $el.append('<i class="tooltip-info-icon fa fa-info-circle no-print"></i>');
            }
            headerCell.appendTo(headerGroupRow);
          });
        }

        // add header row cell
        headerCellLinker(columnScope, function (headerCell) {
          // FIX : Attacher l'élément au DOM (headerRow ou headerGroupRow) AVANT d'injecter le contenu via headerInjector.
          // Cela permet aux directives potentiellement présentes dans le template (comme it-header-cell) 
          // de trouver le contrôleur parent ^infiniTable lors de leur compilation.
          if (hasGroups && group == null) {
            headerCell.attr("rowspan", 2);
            headerCell.appendTo(headerGroupRow);
          } else {
            headerCell.appendTo(headerRow);
          }
          computed.headerInjector(headerCell, columnScope);
          if (column.headerClass) {
            headerCell.addClass(column.headerClass);
          }
          computed.headerCell = headerCell;
        });

        // add content header cell
        contentHeaderCellLinker(columnScope, function (contentHeaderCell) {
          // FIX : Attacher au DOM AVANT injection du contenu pour les mêmes raisons que ci-dessus.
          ui.contentHeadRow.append(contentHeaderCell);
          if (computed.sortable) {
            contentHeaderCell.addClass("it-sortable-column");
          }
          computed.headerInjector(contentHeaderCell, columnScope);
        });
      });
      var $scrollbarTh = $('<th class="scrollbar">').attr("rowspan", hasGroups ? 2 : 1);
      if (hasGroups) {
        $scrollbarTh.appendTo(headerGroupRow);
      } else {
        $scrollbarTh.appendTo(headerRow);
      }
      ui.contentHeadRow.append($('<th class="scrollbar">'));
      ui.contentHeadRow.hide();
    };
    var createHeadGroupRow = function createHeadGroupRow() {
      var headerGroupRowLinker = linkers.headerGroupRow;
      var headerGroupRow = null;
      headerGroupRowLinker($scope, function (_headerGroupRow) {
        headerGroupRow = _headerGroupRow;
        headerGroupRow.prependTo(ui.headTable.find('thead'));
      });
      return headerGroupRow;
    };
    var createHeadHeaderRow = function createHeadHeaderRow() {
      var headerRowLinker = linkers.headerRow;
      var headerRow = null;
      headerRowLinker($scope, function (_headerRow) {
        headerRow = _headerRow;
        headerRow.appendTo(ui.headTable.find('thead'));
      });
      return headerRow;
    };
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/common/itHeaderManager.js
// module id = 2798
// module chunks = 13